/* OP Luxury 2026 / R7 - brands panel.

   One delegated listener filters the wall of houses as you type. The panel
   renders every brand server side, so with scripting off the whole wall is
   still there and only the filter box is inert.

   The panel exists twice on a page (the desktop mega panel and the phone
   drawer), so everything is scoped to the grid that belongs to the input the
   shopper is actually using. */
(function () {
  function normalise(value) {
    return (value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function filter(input) {
    var scope = input.closest('.op-mega__inner');
    if (!scope) return;

    var grid = scope.querySelector('[data-op-brand-grid]');
    var empty = scope.querySelector('[data-op-brand-empty]');
    if (!grid) return;

    var term = normalise(input.value);
    var cells = grid.querySelectorAll('[data-op-brand]');
    var shown = 0;

    for (var i = 0; i < cells.length; i++) {
      var match = !term || normalise(cells[i].getAttribute('data-op-brand')).indexOf(term) > -1;
      cells[i].hidden = !match;
      if (match) shown++;
    }

    if (empty) empty.hidden = shown !== 0;
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('[data-op-brand-search]')) filter(input);
  });

  /* Enter on a filtered wall should go somewhere useful rather than submit a
     form that is not there. One match left means that is the one they meant. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-op-brand-search]')) return;

    var scope = input.closest('.op-mega__inner');
    if (!scope) return;
    var visible = scope.querySelectorAll('[data-op-brand]:not([hidden])');
    if (visible.length !== 1) return;

    var link = visible[0].querySelector('a[href]');
    if (link) {
      event.preventDefault();
      window.location.href = link.getAttribute('href');
    }
  });

  /* A reopened panel should not still be filtered by last time's typing. */
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || !details.querySelector) return;
      if (details.open) return;
      var inputs = details.querySelectorAll('[data-op-brand-search]');
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].value) continue;
        inputs[i].value = '';
        filter(inputs[i]);
      }
    },
    true
  );
})();
